/*  axios拦截器里 设置了4种请求方法
1. 后端要json类型： 直接调用
this.$http.POST_searchTollgate({
                    tollgateNameSearch:item.value
                }).then
2. 后端要FormData 加头部 'Content-Type': 'application/x-www-form-urlencoded类型：用wwwFormData字段，拦截器会用qs序列化
this.$http.POST_searchTollgate({
                    wwwFormData:{  //wwwFormData字段包裹，拦截器写了处理成 序列化 加 headers设置conten-type:application/x-www-form-urlencoded
                        tollgateNameSearch:item.value
                    }
                }).then

3. 后端要params类型
 this.$http.POST_selectApe(
{params:{
    nodeId: data.nodeId
}}
).then
4. 后端在url拼接id如:  /dqi-hymanage/hyEnterprise/find/{id}
 this.$http.POST_selectApe(
{paramsID: data.id}
).then
*/

import axios from 'axios'
import webconfig from '@/web.config.js'
import Qs from 'qs'  //下载axios 自动下载qs模块依赖，无需另外下载
// import Cookies from 'js-cookie'
import router from '@/router'
import store from '@/vuex'
// import toDTO from './DTO'
// import createPersistedState from 'vuex-persistedstate'  //持久化vuex插件，待研究
import { Message } from 'element-ui'
let baseURL = "/api" // 使用代理

// const host = window.location.host
// if (host.indexOf("localhost") > -1) {
//   baseURL = "/api"
//   // 开发环境的主要配置
// // } else if (host.indexOf("10.4.1.") > -1) {
// //   baseURL = "/api"
// } else {
//   baseURL = webconfig.prodHost // 生产环境的主要配置
// }



const axiosConfig = {
  // 基础url前缀
  baseURL,
  // 请求头信息
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
  // 设置超时时间
  timeout: 20000,
  // 携带凭证
  // withCredentials: true,
  // 返回数据类型默认/常用json
  // responseType: 'json'
}




export default options => {
  return new Promise((resolve, reject) => {
    if(typeof(options)==="string"){
      const opt = {
        url:options,
        method:"get"
      }
      options = opt
    }
    const URL = options.url.indexOf(".json") > -1 ? "/static" : axiosConfig.baseURL;  //因为做了2个跨域，然而常用 /api跨域，只有orgList是 /gwApi
    const instance = axios.create({
      baseURL: URL,
      headers: axiosConfig.headers,
      timeout: axiosConfig.timeout,
      transformResponse: [function (data) { }]
    })
    // request 拦截器
    instance.interceptors.request.use(
      config => {
        if (config.data && config.data.wwwFormData) {
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
          config.data = Qs.stringify(config.data.wwwFormData)
        }
		let token = null
        if(localStorage.getItem("userInfo")){
        const userInfo =JSON.parse(localStorage.getItem("userInfo"))
		 token = userInfo.access_token;
		}
        if (config.url.indexOf("/getPublicKey") < 0 && config.url.indexOf("/loginServer") < 0) {
          if(token)config.headers.access_token = token
          else{
            if(config.url.indexOf("/dqi-oamanage/oauth/token") ===-1&&config.url.indexOf("/dqi-hymanage/dict/json") ===-1&&config.url.indexOf("/json/dictionary/vehicleBrand")===-1){
              Message({
                type: "success",
                message: "--已退出登录----",
              });
              router.push("/J3Klogin");
            }
          }
        }
        if(window.localStorage.getItem('MP_ACCESS_TOKEN') !=null){
        let token2 = window.localStorage.getItem('MP_ACCESS_TOKEN');
        config.headers.access_token=token2;
        }
        // 过滤后端抛出的多余的字段
        // if (config.data && toDTO) {
        //   config.data = toDTO(config.data)
        // }
        // if (
        //   config.method === 'post' &&
        //   config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
        // ) {
        //   if (config.data) {
        //     // // 处理提交参数为数组类型的，转化为 以逗号分隔的字符串,注意每个实际项目上的不同进行修改
        //     // Object.keys(config.data).forEach(key => {
        //     //   const item = config.data[key]
        //     //   if (item instanceof Array && item.length > 0) {
        //     //     config.data[key] = item.join(',')
        //     //   }
        //     // })
        //     config.data = Qs.stringify(config.data)  //等同上面的工具
        //   }
        // }
        // else if (
        //   config.method === 'post' &&
        //   config.headers['Content-Type'] === 'application/json;charset=UTF-8'
        // ) {
        //   if (config.data) {
        //     config.data = JSON.stringify(config.data)
        //   }
        // }
        return config
      },

      error => {
        // 请求错误时
        console.log('发生错误request:', error)
        // 1. 判断请求超时
        if (
          error.code === 'ECONNABORTED' &&
          error.message.indexOf('timeout') !== -1
        ) {
          // error.message = 'timeout请求超时'
          // console.log('timeout请求超时')
          // return service.request(originalRequest) // 再重复请求一次
        }
        // 2. 需要重定向到错误页面
        const errorInfo = error.response
        if (errorInfo) {
          error = errorInfo.data // 页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status // 404 403 500 ...
          router.push({
            path: `/error/404`
          })
        }
        return Promise.reject(error) // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    )

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        let data
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        // if (response.headers['content-type'] === 'application/vnd.ms-excel') {
        //   data = response.request.responseText
        // }
        //console.log(99999,response)
        if (response.request.responseType === "blob") {

          data = response.request.response;
          return data
        }


        if (response.headers['content-type'] && response.headers['content-type'].indexOf('image') > -1) {

          data = response.request.responseText // new Buffer(response.request.responseText, 'binary').toString('base64')
        } else if (response.data === undefined) {
          data = response.request.responseText.indexOf('{') == 0 ? JSON.parse(response.request.responseText) : { data: response.request.responseText } //这里触发TIMEOUT
        } else {
          data = response.data
        }
        if ((data.status === 'TIMEOUT'||data.code==='A0230') && response.config.url.indexOf('/logout') === -1) {
          // 返回超时处理
          store.dispatch("user/logout").then(() => {
            Message({
              type: "success",
              message: "--已退出登录!--",
            });
            router.push("/J3Klogin");
            setTimeout(() => {
              history.go(0)
            },1000)
          });
        }
        return data
      },
      error => {
        if (error && error.response) {
          // err = '请求超时'
          switch (error.response.status) {
            case 400:
              error.message = '请求错误'
              break
            case 401:
              error.message = '未授权，请登录'
              break
            case 403:
              error.message = '拒绝访问'
              break
            case 404:
              error.message = `请求地址出错: ${error.response.config.url}`
              break
            case 408:
              error.message = '请求超时'
              break
            case 500:
              error.message = '服务器内部错误'
              console.log(error.response.request.response)
              let msg = JSON.parse(error.response.request.response).msg;
              if(msg !=null && msg !="streamId不存在"){
                error.message = msg;
              }else if(msg == "streamId不存在"){
                error.message = "录像回放重连中";
              }
              break
            case 501:
              error.message = '服务未实现'
              break
            case 502:
              error.message = '网关错误'
              break
            case 503:
              error.message = '服务不可用'
              break
            case 504:
              error.message = '网关超时'
              break
            case 505:
              error.message = 'HTTP版本不受支持'
              break
            default:
              error.message = `连接错误${error.response.status}`
          }
        }
        // else {
        //   error.message = '请求超时，连接到服务器失败'
        // }

        Message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
        return Promise.reject(error) // 返回接口返回的错误信息
      }
    )

    // 请求处理
    instance(options)
      .then(res => {
        resolve(res)
        return false
      })
      .catch(error => {
        reject(error)
      })
  })
}


// WEBPACK FOOTER //
// ./src/http/axiosInstance.js